import { cn } from "./utils";

interface SpinnerProps {
    size?: "sm" | "md" | "lg" | "xl";
    className?: string;
}

export function Spinner({ size = "md", className }: SpinnerProps) {
    const sizeClasses = {
        sm: "w-4 h-4 border-2",
        md: "w-8 h-8 border-2",
        lg: "w-12 h-12 border-4",
        xl: "w-16 h-16 border-4",
    };

    return (
        <div
            className={cn(
                "inline-block animate-spin rounded-full border-muted border-t-blue-500",
                sizeClasses[size],
                className
            )}
            role="status"
            aria-label="Loading"
        >
            <span className="sr-only">Loading...</span>
        </div>
    );
}

interface SpinnerOverlayProps {
    message?: string;
}

export function SpinnerOverlay({ message }: SpinnerOverlayProps) {
    return (
        <div className="fixed inset-0 bg-background flex items-center justify-center z-50">
            <div className="flex flex-col items-center gap-4">
                <Spinner size="xl" />
                {message && (
                    <p className="text-muted-foreground">{message}</p>
                )}
            </div>
        </div>
    );
}

interface SpinnerContainerProps {
    message?: string;
    className?: string;
}

export function SpinnerContainer({ message, className }: SpinnerContainerProps) {
    return (
        <div className={cn("flex flex-col items-center justify-center gap-4 py-12", className)}>
            <Spinner size="lg" />
            {message && (
                <p className="text-muted-foreground">{message}</p>
            )}
        </div>
    );
}